import * as yup from 'yup';

export const optionalEmailSchema = yup
  .string()
  .nullable()
  .email('Email must be a valid email address')
  .notRequired();
